
import { computed, defineComponent, onMounted, reactive, ref } from "vue";
import { copyResult } from "../functions/copyResult";
import CountDown from "./CountDown.vue"
import Timer from "./Timer.vue";

export default defineComponent({
  name: "Statistics",
  components: { CountDown },
  props: ["gridImage", "wordoftheday", "handlesPopUp", "theDate"],
  setup(props) {
    const { gridImage, wordoftheday, handlesPopUp } = props as any;
    
    const handleShare = () => {
      copyResult(gridImage);
      handlesPopUp("הועתק");
    };
    

    return { gridImage, wordoftheday, handleShare };
  },
});
